import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
import { devices_config } from '@devices/index';
import { getXT1BTDeviceFilter } from '../xt1_helpers/template_helpers';
import {
	EXCLUDE_FROM_WEB_BT_INCLUSION,
	CUSTOM_INCLUSION_LIST_FOR_WEB_BT,
} from 'src/configs/web_bluetooth_exclude_devices_filter';
import { isYihao } from '../interface_helpers';
import { sortOn } from '../utilities';

export const getBleFilterDeviceByModel = (): {
	id: string;
	name: string;
	image: string;
}[] => {
	const filterOptions: {
		id: string;
		name: string;
		image: string;
		indexName?: string;
	}[] = CUSTOM_INCLUSION_LIST_FOR_WEB_BT;
	const poweredByShellyDevices = getXT1BTDeviceFilter();
	Object.entries(devices_config).forEach(([type, device]) => {
		if (!EXCLUDE_FROM_WEB_BT_INCLUSION.includes(type)) {
			const id = isYihao(type) ? 'YH-002A-' : device.name + '-';
			const name = device.friendly_name;
			const ifExist = filterOptions.find((i) => i.indexName == name);
			if (!ifExist) {
				const item = {
					id,
					name,
					indexName: name,
					image: `images/device_images/${type}.png`,
					deviceType: type,
				};
				if (/^(Ogemray|Heiman|V-TAC|Cury|EcoFlow|Yihao)/.test(name)) {
					// Devices without "Shelly " prefix (powered by Shelly / partners).
					poweredByShellyDevices.push(item);
				} else {
					filterOptions.push({ ...item, name: 'Shelly ' + name });
				}
			}
		}
	});

	return [
		{
			id: '',
			name: get(format)('any_shelly_device', { default: 'Any Shelly device' }),
			image: 'images/device_images/logo_white_S.png',
		},
		...sortOn(filterOptions, 'name'),
		...sortOn(poweredByShellyDevices, 'name'),
	].map((v, index) => {
		return { ...v, index };
	});
};
